/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TransactionsRouteImport } from './routes/transactions'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ScheduledRouteImport } from './routes/scheduled'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as PlaidOauthRouteImport } from './routes/plaid-oauth'
import { Route as ImportRouteImport } from './routes/import'
import { Route as GoalsRouteImport } from './routes/goals'
import { Route as CoachRouteImport } from './routes/coach'
import { Route as BudgetRouteImport } from './routes/budget'
import { Route as AccountsRouteImport } from './routes/accounts'
import { Route as IndexRouteImport } from './routes/index'

const TransactionsRoute = TransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduledRoute = ScheduledRouteImport.update({
  id: '/scheduled',
  path: '/scheduled',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const PlaidOauthRoute = PlaidOauthRouteImport.update({
  id: '/plaid-oauth',
  path: '/plaid-oauth',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportRoute = ImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => rootRouteImport,
} as any)
const GoalsRoute = GoalsRouteImport.update({
  id: '/goals',
  path: '/goals',
  getParentRoute: () => rootRouteImport,
} as any)
const CoachRoute = CoachRouteImport.update({
  id: '/coach',
  path: '/coach',
  getParentRoute: () => rootRouteImport,
} as any)
const BudgetRoute = BudgetRouteImport.update({
  id: '/budget',
  path: '/budget',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountsRoute = AccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accounts': typeof AccountsRoute
  '/budget': typeof BudgetRoute
  '/coach': typeof CoachRoute
  '/goals': typeof GoalsRoute
  '/import': typeof ImportRoute
  '/plaid-oauth': typeof PlaidOauthRoute
  '/reports': typeof ReportsRoute
  '/scheduled': typeof ScheduledRoute
  '/settings': typeof SettingsRoute
  '/transactions': typeof TransactionsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accounts': typeof AccountsRoute
  '/budget': typeof BudgetRoute
  '/coach': typeof CoachRoute
  '/goals': typeof GoalsRoute
  '/import': typeof ImportRoute
  '/plaid-oauth': typeof PlaidOauthRoute
  '/reports': typeof ReportsRoute
  '/scheduled': typeof ScheduledRoute
  '/settings': typeof SettingsRoute
  '/transactions': typeof TransactionsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accounts': typeof AccountsRoute
  '/budget': typeof BudgetRoute
  '/coach': typeof CoachRoute
  '/goals': typeof GoalsRoute
  '/import': typeof ImportRoute
  '/plaid-oauth': typeof PlaidOauthRoute
  '/reports': typeof ReportsRoute
  '/scheduled': typeof ScheduledRoute
  '/settings': typeof SettingsRoute
  '/transactions': typeof TransactionsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accounts'
    | '/budget'
    | '/coach'
    | '/goals'
    | '/import'
    | '/plaid-oauth'
    | '/reports'
    | '/scheduled'
    | '/settings'
    | '/transactions'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accounts'
    | '/budget'
    | '/coach'
    | '/goals'
    | '/import'
    | '/plaid-oauth'
    | '/reports'
    | '/scheduled'
    | '/settings'
    | '/transactions'
  id:
    | '__root__'
    | '/'
    | '/accounts'
    | '/budget'
    | '/coach'
    | '/goals'
    | '/import'
    | '/plaid-oauth'
    | '/reports'
    | '/scheduled'
    | '/settings'
    | '/transactions'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountsRoute: typeof AccountsRoute
  BudgetRoute: typeof BudgetRoute
  CoachRoute: typeof CoachRoute
  GoalsRoute: typeof GoalsRoute
  ImportRoute: typeof ImportRoute
  PlaidOauthRoute: typeof PlaidOauthRoute
  ReportsRoute: typeof ReportsRoute
  ScheduledRoute: typeof ScheduledRoute
  SettingsRoute: typeof SettingsRoute
  TransactionsRoute: typeof TransactionsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/transactions': {
      id: '/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof TransactionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduled': {
      id: '/scheduled'
      path: '/scheduled'
      fullPath: '/scheduled'
      preLoaderRoute: typeof ScheduledRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plaid-oauth': {
      id: '/plaid-oauth'
      path: '/plaid-oauth'
      fullPath: '/plaid-oauth'
      preLoaderRoute: typeof PlaidOauthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/import': {
      id: '/import'
      path: '/import'
      fullPath: '/import'
      preLoaderRoute: typeof ImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/goals': {
      id: '/goals'
      path: '/goals'
      fullPath: '/goals'
      preLoaderRoute: typeof GoalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coach': {
      id: '/coach'
      path: '/coach'
      fullPath: '/coach'
      preLoaderRoute: typeof CoachRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/budget': {
      id: '/budget'
      path: '/budget'
      fullPath: '/budget'
      preLoaderRoute: typeof BudgetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounts': {
      id: '/accounts'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountsRoute: AccountsRoute,
  BudgetRoute: BudgetRoute,
  CoachRoute: CoachRoute,
  GoalsRoute: GoalsRoute,
  ImportRoute: ImportRoute,
  PlaidOauthRoute: PlaidOauthRoute,
  ReportsRoute: ReportsRoute,
  ScheduledRoute: ScheduledRoute,
  SettingsRoute: SettingsRoute,
  TransactionsRoute: TransactionsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
